import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContactUs } from 'src/models/interfaces/contact-us/contact-us.interface';
import { HeadersService } from '../header.service';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {
  private readonly contactUsUrl = `${environment.apiUrl}/api/v1/emails/faleconosco`;

  constructor(private readonly http: HttpClient, private headersService: HeadersService) {
    this.headersService.includeObject({ fileName: 'contact-us.service.ts', url: this.contactUsUrl });
  }

  public readonly createContactUs = (contactUs: ContactUs): Observable<{ message: string }> => {
    return this.http.post<{ message: string }>(this.contactUsUrl, contactUs);
  };
}
